import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { auth0Config } from "../../Config/auth0Conifg";
import axiosSecure from "../../Services/Serverless/axiosSecure";

function CallServerButton() {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const [token, setToken] = useState<string | null>(null);
  const [response, setResponse] = useState<string | null>(null);

  useEffect(() => {
    if (token === null && isAuthenticated) {
      getAccessTokenSilently({
        authorizationParams: {
          audience: auth0Config.audience,
        },
      }).then((accessToken) => {
        setToken(accessToken);
      });
    }
  }, [isAuthenticated]);

  const callServer = async () => {
    if (token !== null) {
      const result = await axiosSecure(token).post(`/secure-hello-http`);
      setResponse(result.data);
    }
  };
  if (token === null) <div>loading</div>;
  return (
    <div>
      <h2>Call Server</h2>
      <button onClick={callServer}>Call Hello</button>
      <div>
        <pre>{JSON.stringify(response)}</pre>
      </div>
      <h2>AccessToken</h2>
      <textarea readOnly style={{ width: "100%" }} value={token || ""} />
    </div>
  );
}

export default CallServerButton;
